export const API_ENDPOINTS = {
  // login page ---
  "userLogin": "login",

  // logout
  "userLogout": "logout",

  //listing Page APIs
  "list-complaints": "fetchComplainList",
  "complaints-status": "fetchComplaintsStatus",


  //details Page APIs
  "complaint-details": "fetchComplainDetail",
  "add-comments": "addComments",
  "list-action-items": "list_action_items",
  "list-cards": "DashBoardDetails",
  'ulb-action-status': "update_status",
  'download-pdf': 'pdf_generator',
  'dropdown-list': "list_transfer_assignment",
  "asign-transfer": "assign_or_transfer",
  "ulb-csv-download": "download/ulb_complaints",
  "close-complaint": "close_complaint",


  // Inbox page APIs
  "list-inbox": "complaints_inbox",
  "list-selected-inbox": "org_complaints_inbox",

  // Download reports
  "download-reports":"admin_complaints_excel"

};

export const API_ENVIRONMENT = {
  "company-info": "local",
  // 'userLogin': 'dev',
};